import React from 'react';
import TextSummaryCard from './TextSummaryCard';

interface FupSummaryCardProps {
  value?: string | null;
}

const FupSummaryCard: React.FC<FupSummaryCardProps> = ({ value }) => (
  <TextSummaryCard
    title="Resumo do FUP"
    value={value}
    emptyText="Não há resumo do FUP."
  />
);

export default FupSummaryCard;
